'use strict';

var debounce = require('lodash/debounce');
var imagesLoaded = require('imagesloaded/imagesloaded');
var currentWindowWidth = window.innerWidth;

/**
 * Get the current sticky header height dynamically
 * @returns {number} The height of the sticky header in pixels
 */
function getStickyHeaderHeight() {
    // Try common header selectors
    var $header = $('.header, .site-header, header[role="banner"], .navbar, .page-header').first();

    if ($header.length && $header.css('position') === 'fixed') {
        return $header.outerHeight() || 0;
    }

    // Fallback to default if no sticky header found
    return 105;
}

/**
 * Function for Initializing Slick Carousel
 * @param {Object} curreEle - Get the current carousel element
 * @param {Object} slidesToDisplay - Count of Slides To Display
 * @param {Object} slidesToScroll - Count of Slides To Scroll
 * @param {Object} displayIndicators - Control to Display dots
 * @param {Object} displayControls - Control to Display Arrows
 */
function slickCarousel(curreEle, slidesToDisplay, slidesToScroll, displayIndicators, displayControls) {
    var $slickCarouselItem = $(curreEle).find('.slick-carousel-item');

    if ($slickCarouselItem.hasClass('slick-initialized')) {
        $slickCarouselItem.slick('unslick');
    }

    $slickCarouselItem.slick({
        infinite: false,
        speed: 300,
        dots: displayIndicators.lg,
        arrows: displayControls.lg,
        slidesToShow: slidesToDisplay.lg,
        slidesToScroll: slidesToScroll.lg,
        prevArrow: '<button type="button" class="slide-arrow prev-arrow" aria-label="Previous slide"> <span class="svg-left-arrow"> </span> </button>',
        nextArrow: '<button type="button" class="slide-arrow next-arrow" aria-label="Next slide"> <span class="svg-right-arrow"> </span> </button>',
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    dots: displayIndicators.md,
                    arrows: displayControls.md,
                    slidesToShow: slidesToDisplay.md,
                    slidesToScroll: slidesToScroll.md
                }
            },
            {
                breakpoint: 992,
                settings: {
                    dots: displayIndicators.sm,
                    arrows: displayControls.sm,
                    slidesToShow: slidesToDisplay.sm,
                    slidesToScroll: slidesToScroll.sm
                }
            },
            {
                breakpoint: 767,
                settings: {
                    dots: displayIndicators.xs,
                    arrows: displayControls.xs,
                    slidesToShow: slidesToDisplay.xs,
                    slidesToScroll: slidesToScroll.xs
                }
            }
        ]
    }).on('afterChange', function (event, slick) {
        var carouselRender = setInterval(function () {
            var $currTarget = $('.slick-carousel-product');
            $currTarget.each(function () {
                var $currentList = $(this).find('.slick-list');
                var $currentEle = $currentList.find('.slick-active:first img');
                var arrowTopPos = $currentEle.height() / 2;
                $(this).find('.slick-arrow span').css('top', (arrowTopPos - 20) + 'px');
                $(this).find('.slick-arrow').css('height', $currentEle.height() + 'px');
                clearInterval(carouselRender);
            });
        }, 100);

        // Update focusable elements after slide change
        if (slick && slick.$slider) {
            var $carousel = $(slick.$slider);
            $carousel.find('.slick-slide:not(.slick-active)').find('a, button, input, select, textarea, [tabindex="0"]').attr('tabindex', '-1');
            $carousel.find('.slick-slide.slick-active').find('a, button, input, select, textarea, [tabindex="-1"]').attr('tabindex', '0');
        }
    }).trigger('afterChange');

    // Initialize carousel tracking early, before event handlers
    var $carousel = $(curreEle);
    var carouselId = $carousel.attr('id') || 'carousel-' + Date.now();

    // Store carouselId as data attribute for later reference
    $carousel.data('carouselId', carouselId);

    // Store tracking data on window to persist across all carousels
    if (!window.carouselFocusTracking) {
        window.carouselFocusTracking = {};
    }

    window.carouselFocusTracking[carouselId] = {
        isInsideCarousel: false,
        lastFocusWasProgrammatic: false
    };

    // Handle click events
    $slickCarouselItem.on('click', '.prev-arrow, .next-arrow, .slick-dots button, .slick-dots li', function () {
        var $currTarget = $(this).closest('.slick-carousel-product');
        var $currentList = $currTarget.find('.slick-list');
        var slicklenth = $currTarget.find('.slick-slide').length;
        var firstSlide = $currentList.find('.slick-active:first').data('slick-index');
        var lastSlide = $currentList.find('.slick-active:last').data('slick-index');

        if (firstSlide === 0) {
            $currentList.removeClass('slickmiddle slicklast');
        } else {
            $currentList.removeClass('slicklast');
            $currentList.addClass('slickmiddle');
        }

        if (lastSlide === slicklenth - 1) {
            $currentList.removeClass('slickmiddle');
            $currentList.addClass('slicklast');
        }
    });

    // Track the last interaction type globally for this carousel
    var lastInteractionType = 'mouse'; // 'mouse' or 'keyboard'
    var lastInteractionTime = 0;
    var keyboardFocusOnArrow = false; // Track if arrow button was focused via keyboard
    var mousedownOnArrow = false; // Track if there was a recent mousedown on arrow (indicating mouse click)

    // Handle keyboard navigation on arrow buttons
    $slickCarouselItem.on('keydown', '.prev-arrow, .next-arrow', function (event) {
        // Only handle Enter (13) and Space (32) key presses
        if (!(event.which === 13 || event.which === 32)) {
            return;
        }

        // Prevent default to avoid scrolling on space
        event.preventDefault();

        // Mark this interaction as keyboard-triggered
        $(this).data('keyboardTriggered', true);

        // Store globally that keyboard was used
        lastInteractionType = 'keyboard';
        lastInteractionTime = Date.now();

        // Trigger click to navigate
        $(this).trigger('click');
    });

    // Detect mouse clicks on arrows
    // IMPORTANT: NVDA simulates mousedown when you press Enter/Space, so we need to check
    // if the element has keyboard focus before marking as mouse interaction
    $slickCarouselItem.on('mousedown', '.prev-arrow, .next-arrow', function () {
        // Real mouse click scenario:
        // - Arrow doesn't have focus yet (user will click and it will receive focus)
        // - OR arrow has focus but keyboardFocusOnArrow is false (focus was gained via previous mouse click)
        // NVDA scenario:
        // - Arrow already has focus (via Tab)
        // - keyboardFocusOnArrow is true (was set when arrow received focus via Tab)
        if (!keyboardFocusOnArrow) {
            // This is a real mouse click (not NVDA)
            lastInteractionType = 'mouse';
            lastInteractionTime = Date.now();
            mousedownOnArrow = true;

            // Reset the flag after focusin has a chance to process
            setTimeout(function () {
                mousedownOnArrow = false;
            }, 50);
        }
    });

    // Handle click events: move focus to current slide after keyboard-triggered arrow click
    $slickCarouselItem.on('click', '.prev-arrow, .next-arrow', function () {
        var $arrow = $(this);
        var wasKeyboardTriggered = $arrow.data('keyboardTriggered');

        // Check if the arrow currently has focus (NVDA may trigger click without keydown)
        var arrowHasFocus = document.activeElement === this;

        // Check both the data attribute AND the global tracker
        // ALSO check if the arrow has focus (NVDA scenario)
        var timeSinceInteraction = Date.now() - lastInteractionTime;
        var isKeyboardInteraction = wasKeyboardTriggered ||
                                   (lastInteractionType === 'keyboard' && timeSinceInteraction < 500) ||
                                   (arrowHasFocus && keyboardFocusOnArrow);

        // Don't clear the flag immediately - delay it to handle multiple click events from Slick
        // This ensures all click handlers see the same value
        setTimeout(function () {
            $arrow.removeData('keyboardTriggered');
        }, 50);

        // Mark this as programmatic to prevent scroll during mouse navigation
        // ONLY block focus during MOUSE navigation, NOT keyboard navigation
        if (!isKeyboardInteraction && window.carouselFocusTracking && window.carouselFocusTracking[carouselId]) {
            window.carouselFocusTracking[carouselId].lastFocusWasProgrammatic = true;

            // Set a flag to block focus during mouse navigation
            window.carouselFocusTracking[carouselId].blockFocus = true;

            // Reset the flags after navigation completes
            setTimeout(function () {
                if (carouselId && window.carouselFocusTracking && window.carouselFocusTracking[carouselId]) {
                    window.carouselFocusTracking[carouselId].lastFocusWasProgrammatic = false;
                    window.carouselFocusTracking[carouselId].blockFocus = false;
                }
            }, 300);
        } else if (isKeyboardInteraction && window.carouselFocusTracking && window.carouselFocusTracking[carouselId]) {
            // For keyboard navigation, ensure blockFocus is FALSE
            window.carouselFocusTracking[carouselId].blockFocus = false;
            window.carouselFocusTracking[carouselId].lastFocusWasProgrammatic = true;
        }

        // Only move focus if this was triggered by keyboard, not by mouse
        if (isKeyboardInteraction) {
            // Check if carousel is in viewport
            var carouselTop = curreEle.getBoundingClientRect().top;
            var stickyHeaderHeight = getStickyHeaderHeight();
            var isCarouselVisible = carouselTop >= stickyHeaderHeight;

            // If carousel is not fully visible, scroll it into view first
            if (!isCarouselVisible) {
                var $carouselTitle = $carousel.prev('.row').find('.carousel-title');
                var elementToScroll = curreEle;

                if ($carouselTitle.length > 0) {
                    elementToScroll = $carouselTitle.closest('.row')[0];
                }

                var additionalMargin = 40;
                var elementTop = elementToScroll.getBoundingClientRect().top + window.pageYOffset;
                var offsetPosition = elementTop - stickyHeaderHeight - additionalMargin;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }

            // Move focus to the first focusable element in the current slide after navigation completes
            // Use requestAnimationFrame to ensure better synchronization with screen readers like NVDA
            setTimeout(function () {
                var $keyboardList = $carousel.find('.slick-list');
                var $currentSlide = $keyboardList.find('.slick-active:first');
                var $focusableElement = $currentSlide.find('a, button, [tabindex="0"]').first();

                if ($focusableElement.length) {
                    // Mark this specific focus as programmatic to prevent duplicate scroll from focusin listener
                    if (window.carouselFocusTracking && window.carouselFocusTracking[carouselId]) {
                        window.carouselFocusTracking[carouselId].lastFocusWasProgrammatic = true;
                    }

                    var targetElement = $focusableElement[0];

                    // Use requestAnimationFrame to synchronize with browser rendering
                    // This helps ensure NVDA processes the focus correctly
                    requestAnimationFrame(function () {
                        targetElement.focus();

                        // Verify focus was set correctly after a short delay
                        // If NVDA or another screen reader moved focus away, restore it
                        setTimeout(function () {
                            var currentActive = document.activeElement;
                            var focusLostToBody = currentActive === document.body;
                            var focusOnWrongElement = currentActive !== targetElement;

                            if (focusOnWrongElement && focusLostToBody) {
                                // Focus was lost to body - restore it
                                targetElement.focus();
                            }

                            // Reset the programmatic flag after focus is confirmed
                            if (window.carouselFocusTracking && window.carouselFocusTracking[carouselId]) {
                                window.carouselFocusTracking[carouselId].lastFocusWasProgrammatic = false;
                            }
                        }, 100);
                    });
                }
            }, 150);
        }
    });

    // Block focus on slides during mouse navigation to prevent :focus-within from triggering alt image
    curreEle.addEventListener('focusin', function (event) {
        var tracking = window.carouselFocusTracking[carouselId];

        // Check if focus is on an arrow button
        var $target = $(event.target);
        var isArrowButton = $target.hasClass('prev-arrow') || $target.hasClass('next-arrow');

        if (isArrowButton) {
            // Only set keyboardFocusOnArrow if this focus was NOT caused by a mouse click
            // If mousedownOnArrow is true, it means this focus is from a mouse click
            if (!mousedownOnArrow) {
                keyboardFocusOnArrow = true;
            }
        }

        // If blockFocus flag is set (mouse navigation), prevent focus on slide elements
        if (tracking.blockFocus) {
            var $slickList = $carousel.find('.slick-list');
            var isWithinSlides = $slickList.find(event.target).length > 0;

            // If focus is attempting to go to an element within slides, blur it immediately
            if (isWithinSlides) {
                event.target.blur();
                event.preventDefault();
                event.stopPropagation();
                return;
            }
        }

        var wasOutside = !tracking.isInsideCarousel;
        var $focusedElement = $(event.target);

        // Check if focus is on carousel controls (arrows or dots) - these should not trigger scroll
        var isCarouselControl = $focusedElement.hasClass('prev-arrow') ||
                                $focusedElement.hasClass('next-arrow') ||
                                $focusedElement.closest('.slick-dots').length > 0 ||
                                $focusedElement.closest('.prev-arrow').length > 0 ||
                                $focusedElement.closest('.next-arrow').length > 0;

        // Scroll should happen when:
        // 1. Focus is entering from outside the carousel (wasOutside = true) AND
        // 2. It's not programmatic focus (from clicking arrows) AND
        // 3. It's not focus on carousel controls themselves
        // This ensures scroll works for Tab/Shift+Tab navigation into carousel content
        if (wasOutside && !tracking.lastFocusWasProgrammatic && !isCarouselControl) {
            // Always scroll the element into view when focus enters from outside
            // This ensures consistent behavior across browsers
            setTimeout(function () {
                var stickyHeaderHeight = getStickyHeaderHeight();
                var additionalMargin = 40;

                // Check if the focused element is visible in the viewport
                var focusedElementRect = event.target.getBoundingClientRect();
                var focusedElementTop = focusedElementRect.top;
                var focusedElementBottom = focusedElementRect.bottom;
                var viewportHeight = window.innerHeight;

                // Element is not fully visible if:
                // - Top is above the sticky header, or
                // - Bottom is below the viewport
                var isFullyVisible = focusedElementTop >= stickyHeaderHeight &&
                                    focusedElementBottom <= viewportHeight;

                if (!isFullyVisible) {
                    var scrollTarget;

                    // If element is below viewport, just bring it into view
                    if (focusedElementBottom > viewportHeight) {
                        // Scroll just enough to show the element at the bottom of viewport
                        scrollTarget = window.pageYOffset + (focusedElementBottom - viewportHeight) + additionalMargin;
                    } else {
                        // Element is above viewport or partially hidden by header
                        // Scroll to show the carousel title (if exists) or carousel top
                        var $carouselTitle = $(curreEle).prev('.row').find('.carousel-title');
                        var elementToScroll = curreEle;

                        if ($carouselTitle.length > 0) {
                            elementToScroll = $carouselTitle.closest('.row')[0];
                        }

                        var elementTop = elementToScroll.getBoundingClientRect().top + window.pageYOffset;
                        scrollTarget = elementTop - stickyHeaderHeight - additionalMargin;
                    }

                    window.scrollTo({
                        top: scrollTarget,
                        behavior: 'smooth'
                    });
                }
            }, 10);
        }

        tracking.isInsideCarousel = true;
    }, true);

    // Track when focus leaves the carousel
    curreEle.addEventListener('focusout', function (event) {
        var tracking = window.carouselFocusTracking[carouselId];

        // Check if focus is leaving an arrow button
        var $target = $(event.target);
        var isArrowButton = $target.hasClass('prev-arrow') || $target.hasClass('next-arrow');

        if (isArrowButton) {
            setTimeout(function () {
                keyboardFocusOnArrow = false;
            }, 100);
        }

        // Check if focus is leaving the carousel entirely (not just moving between child elements)
        setTimeout(function () {
            var focusStillInCarousel = event.relatedTarget && $(event.relatedTarget).closest(curreEle).length > 0;

            if (!focusStillInCarousel) {
                tracking.isInsideCarousel = false;
            }
        }, 0);
    }, true);
}

/**
 * Retrieving the product list from the template and generating sliders for each product.
 * @param {Object} curreEle - Get the current carousel element
 */
function carouselComponent(curreEle) {
    var $carouselProduct = $(curreEle);
    var $productView = $carouselProduct.find('.product-view');
    var displayProducts = $productView.data();

    var slidesToDisplay = {
        xs: $carouselProduct.data('xs'),
        sm: $carouselProduct.data('sm'),
        md: $carouselProduct.data('md'),
        lg: $carouselProduct.data('lg')
    };

    var slidesToScroll = {
        xs: $carouselProduct.data('xs'),
        sm: $carouselProduct.data('sm'),
        md: $carouselProduct.data('md'),
        lg: $carouselProduct.data('lg')
    };

    var displayIndicators = {
        xs: $carouselProduct.data('xs-dots'),
        sm: $carouselProduct.data('sm-dots'),
        md: $carouselProduct.data('md-dots'),
        lg: $carouselProduct.data('lg-dots')
    };

    var displayControls = {
        xs: $carouselProduct.data('xs-arrows'),
        sm: $carouselProduct.data('sm-arrows'),
        md: $carouselProduct.data('md-arrows'),
        lg: $carouselProduct.data('lg-arrows')
    };

    if (displayProducts !== undefined && displayProducts !== null) {
        if (window.matchMedia('(max-width: 767px)').matches) {
            displayProducts = displayProducts.mobileproductscount;
        } else if (window.matchMedia('(max-width: 1023px)').matches) {
            displayProducts = displayProducts.tabletproductscount;
        } else {
            displayProducts = displayProducts.desktopproductscount;
        }

        $productView.each(function (index, view) {
            if (index < displayProducts) {
                $(view).addClass('in-list');
            } else {
                $(view).detach();
            }
        }).promise().done(function () {
            var imageEle = $(curreEle).find('.slick-carousel-item img:first');
            imagesLoaded(imageEle).on('done', function () {
                slickCarousel(curreEle, slidesToDisplay, slidesToScroll, displayIndicators, displayControls);
            });
        });
    } else {
        slickCarousel(curreEle, slidesToDisplay, slidesToScroll, displayIndicators, displayControls);
    }
}

module.exports = {
    carouselComponent: function () {
        $('.slick-carousel-product').each(function () {
            carouselComponent(this);
        });
    },

    windowResizeEvent: function () {
        $(window).on('resize', debounce(function () {
            if (currentWindowWidth !== window.innerWidth) {
                $('.slick-carousel-product').each(function () {
                    carouselComponent(this);
                    currentWindowWidth = window.innerWidth;
                });
            }
        }, 500));
    }
};
